import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable, InjectionToken } from '@angular/core';
import { SCDPerson } from '@tran-monorepo/interfaces';
import { Observable } from 'rxjs';

export const SCD_API_URL = new InjectionToken<string>('SCD_API_URL');

@Injectable({
    providedIn: 'root'
})
export class ScdService {
    private readonly http = inject(HttpClient);
    private readonly apiUrl = inject(SCD_API_URL);

    public findAll(searchTerm: string): Observable<SCDPerson[]> {
        const params = new HttpParams().set('searchTerm', searchTerm);
        return this.http.get<SCDPerson[]>(`${this.apiUrl}/persons`, { params });
    }

    public findOne(gid: string): Observable<SCDPerson> {
        return this.http.get<SCDPerson>(`${this.apiUrl}/persons/${gid}`);
    }
}
